import { ReactNode } from "react"

import { FullInterval } from "../../../libs/dates/interval"
import { Preset } from "../../../libs/dates/presets"

interface BaseFilterT {
  key: string
  value: string
  onClear: () => void
}

export const FilterType = {
  Text: "text",
  Date: "date",
} as const
export type FilterType = (typeof FilterType)[keyof typeof FilterType]

export const DisabledMode = {
  None: "none",
  Past: "past",
  Future: "future",
} as const
export type DisabledModeT = (typeof DisabledMode)[keyof typeof DisabledMode]

export interface TextFilterT extends BaseFilterT {
  type: typeof FilterType.Text
  options: OptionT[]
  selectedOptions: OptionT[]
  onSelectOption: (option: OptionT) => void
  autoFilterOptions?: boolean
  onChangeQuery?: (query: string) => void
  onLoadMore?: () => void
  maxRenderedItems?: number
}

interface DateFilterT extends BaseFilterT {
  type: typeof FilterType.Date
  defaultPreset: Preset
  presetsToDisplay: Preset[]
  selectedDateRange: FullInterval | null
  onSelectDateRange: (dateRange: FullInterval) => void
  disabledMode: DisabledModeT
}

export type FilterT = TextFilterT | DateFilterT

export interface OptionT {
  key: string
  value: string
  content?: ReactNode
}

export interface FilterProps {
  filters: FilterT[]
  selectedFilter: FilterT | null
  onSelectFilterKey: (key: string) => void
  onDeleteFilter: () => void
  isInModal?: boolean
}
